import es from './es.json';
import en from './en.json';
import fr from './fr.json';
import ca from './ca.json';
const translations = {
    es,
    en,
    fr,
    ca
}

const transl = (key, language = 'es', args = []) => {
    let translation = translations[language][key] || key;

    if (args.length > 0) {
        // Replace placeholders in the translation with provided arguments
        translation = translation.replace(/{(\d+)}/g, (match, index) => {
            const argIndex = parseInt(index, 10);
            return args[argIndex] !== undefined ? args[argIndex] : match;
        });
    }

    return translation;
    //return translations[language][key] || key;
}

export default transl
